import { DateTime } from 'luxon'

export const configDateInitial = (addDays: number) => {
  return new Date(new Date().getTime() - addDays * 24 * 60 * 60 * 1000)
    .toISOString()
    .split('T')[0]
}

export const ConvertDateToUTC = (date: Date) => {
  const timezoneOffset = new Date().getTimezoneOffset()

  const utcDate = new Date(date)

  utcDate.setTime(date.getTime() + timezoneOffset * 60 * 1000)

  return utcDate.toISOString()
}

export const ConvertDateSqlToJS = (sqlDate: any) => {
  // En el caso de que la fecha traiga 'T' se reemplaza por espacio
  if (sqlDate.toString().indexOf('T') !== -1) {
    sqlDate = sqlDate.toString().replace('T', ' ')
  }

  // sqlDate en formato SQL DATETIME ("yyyy-mm-dd hh:mm:ss.ms")
  const sqlDateArr1 = sqlDate.split('-')

  // formateo de sqlDateArr1[] = ['yyyy','mm','dd hh:mm:ms']
  const sYear = sqlDateArr1[0]
  const sMonth = Number(sqlDateArr1[1]) - 1
  const sqlDateArr2 = sqlDateArr1[2].split(' ')

  // formateo de sqlDateArr2[] = ['dd', 'hh:mm:ss.ms']
  const sDay = sqlDateArr2[0]
  const sqlDateArr3 = sqlDateArr2[1].split(':')

  // formateo de sqlDateArr3[] = ['hh','mm','ss.ms']
  const sHour = parseInt(sqlDateArr3[0]) - new Date().getTimezoneOffset() / 60
  const sMinute = sqlDateArr3[1]

  const sqlDateArr4 = sqlDateArr3[2].split('.')

  // formateo de sqlDateArr4[] = ['ss','ms']
  const sSecond = sqlDateArr4[0]
  let sMillisecond = 0
  if (sqlDateArr3[2].indexOf('.') !== -1) {
    sMillisecond = sqlDateArr4[1].substr(0, 2)
  }

  return new Date(
    sYear,
    sMonth,
    sDay,
    sHour,
    sMinute,
    sSecond,
    sMillisecond
  ).toLocaleString('es-ES', {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  })
}

export const ConvertDateJSToString = (dateJS: string) => {
  const dateString = dateJS.toString()

  const dateArray = dateString.substr(0, 9).split('/')
  const hour = dateString.split(' ')[1]

  const day =
    parseInt(dateArray[0]) >= 10 ? `${dateArray[0]}` : `0${dateArray[0]}`

  const month =
    parseInt(dateArray[1]) >= 10
      ? `${dateArray[1].toString()}`
      : `0${dateArray[1]}`

  const year = dateArray[2]

  const dateStringFull = `${day}/${month}/${year} ${hour}`

  return dateStringFull
}

export const setToInitialDateTime = (strDate: string) => {
  return new Date(`${strDate} 00:00:00`).toISOString()
}

export const setToFinalDateTime = (strDate: string) => {
  return new Date(`${strDate} 23:59:59`).toISOString()
}

export const daysBetweenTwoDates = (
  date1: Date | string,
  date2: Date | string,
  hour24: boolean = false
) => {
  let dateOne: Date = new Date()
  let dateTwo: Date = new Date()

  if (typeof date1 === 'string') dateOne = new Date(date1)
  else dateOne = date1

  if (typeof date2 === 'string') dateTwo = new Date(date2)
  else dateTwo = date2

  const timeDifference = dateTwo.getTime() - dateOne.getTime()

  const daysDifference = timeDifference / (1000 * 60 * 60 * 24)

  return hour24 ? daysDifference + 1 : daysDifference
}

export const getCurrentDate = (daysBefore?: number) => {
  const currentdate = new Date()

  if (daysBefore !== undefined)
    currentdate.setDate(currentdate.getDate() - daysBefore)

  const datetime =
    currentdate.getFullYear() +
    '-' +
    (currentdate.getMonth() + 1).toString().padStart(2, '0') +
    '-' +
    currentdate.getDate().toString().padStart(2, '0') +
    'T' +
    currentdate.getHours().toString().padStart(2, '0') +
    ':' +
    currentdate.getMinutes().toString().padStart(2, '0') +
    ':' +
    currentdate.getSeconds().toString().padStart(2, '0')

  return datetime
}

export const utcToLocal = (
  date: Date | string | undefined,
  format?: string
) => {
  if (!date) {
    return 'Sin fecha'
  }
  // Generamos objeto DateTime Luxon UTC
  const utcDate = DateTime.fromISO(date.toString(), {
    zone: 'utc'
  })

  // Obtenemos la hora local
  const localDate = utcDate.toLocal()

  if (format) {
    return localDate.toFormat(format)
  }

  return localDate.toFormat("yyyy-MM-dd'T'HH:mm:ss")
}

export const localDateFromInput = (inputValue: string) => {
  return DateTime.fromISO(`${inputValue}T00:00:00`)
    .toUTC()
    .toFormat("yyyy-MM-dd'T'HH:mm:ss")
}

export const localDate = () => {
  return DateTime.fromISO(`${DateTime.local().toFormat('yyyy-MM-dd')}T00:00:00`)
    .toUTC()
    .toFormat("yyyy-MM-dd'T'HH:mm:ss")
}

export const utcIntialDate = (date: string) => {
  return DateTime.fromISO(`${date}T00:00:00`)
    .toUTC()
    .toFormat("yyyy-MM-dd'T'HH:mm:ss")
}

export const utcFinalDate = (date: string) => {
  return DateTime.fromISO(`${date}T23:59:59`)
    .toUTC()
    .toFormat("yyyy-MM-dd'T'HH:mm:ss")
}

// se usa para formatear la fecha con formato fecha de table storage y valida el tipo de dato ya que se usa en (formater) de la tabla generica y viene con valor UnkNow
/**
 * Formatea fechas de expiración (solo año-mes-día) SIN conversión de zona horaria
 * Las fechas de vencimiento son fechas calendario, no timestamps UTC
 * @param date - Fecha en formato ISO (YYYY-MM-DD) o objeto Date
 * @param format - Formato de salida (default: 'dd-MM-yyyy')
 * @returns Fecha formateada o 'N/A' si es nula/undefined
 */
export const formatExpirationDate = (
  date: string | Date | null | undefined,
  format: string = 'dd-MM-yyyy'
): string => {
  if (!date) return 'N/A'

  // Si es un objeto Date, convertirlo a DateTime de Luxon
  // Si es string, parsearlo como ISO
  // Ambos casos se tratan como fecha local, NO como UTC para evitar cambio de día
  const dateTime =
    date instanceof Date ? DateTime.fromJSDate(date) : DateTime.fromISO(date)

  return dateTime.toFormat(format)
}

// Esto es lo mismo que se hace para la fecha de expiración
// Hay casos donde queremos solo mostrar la fecha ConvertDateSqlToJS
// y no pasarlo a UTC.
// Se separa solo por si en el futuro, hay que hacer algo en fecha de expiración
// si afectar a otras fechas que reciben el mismo comportamiento (estimatedDate en ASN i.e)
export const formatNonUTCDate = (
  date: string | Date | null | undefined,
  format: string = 'dd-MM-yyyy'
): string => {
  if (!date) return 'N/A'

  const dateTime =
    date instanceof Date ? DateTime.fromJSDate(date) : DateTime.fromISO(date)

  return dateTime.toFormat(format)
}

export const fechaFormateada = (
  fecha: string | undefined | unknown,
  format?: string
): string => {
  // Verificar si la fecha es undefined o null
  if (fecha === undefined || fecha === null) return 'sin fecha'

  if (typeof fecha !== 'string') return 'sin fecha'

  return utcToLocal(fecha, format)
}
